import { Logger } from "@wemade-vsf/core";
const addItemCommand = {
  execute: async (context, {
    product,
    customOptions,
    quantity,
    currentCart,
    productConfiguration
  }) => {
    var _a, _b, _c, _d;
    Logger.debug("[Magento]: Add item to quote cart", {
      product,
      quantity,
      currentCart
    });
    const apiState = context.$magento.config.state;
    const cartId = apiState.getQuoteCartId();
    if (!product) {
      return;
    }
    switch (product.__typename) {
      case "SimpleProduct":
        const simpleCartInput = {
          cart_id: cartId,
          cart_items: [
            {
              data: {
                quantity,
                sku: product.sku
              },
              ...(customOptions == null ? void 0 : customOptions.length) ? { customizable_options: customOptions } : {}
            }
          ]
        };
        const simpleProduct = await context.$magento.api.addSimpleProductsToQuote(
          simpleCartInput
        );
        Logger.debug("[Result]:", { data: simpleProduct.data });
        if (((_a = simpleProduct.errors) == null ? void 0 : _a.length) > 0) {
          throw new Error(String(simpleProduct.errors[0].message));
        }
        return simpleProduct.data.addSimpleProductsToCart.cart;
      case "ConfigurableProduct":
        const selectedOptions = productConfiguration ? Object.values(productConfiguration) : null;
        const configurableCartInput = {
          cart_id: cartId,
          cart_items: [
            {
              parent_sku: product.sku,
              data: {
                quantity,
                sku: product.configurable_product_options_selection.variant.sku,
                selected_options: selectedOptions
              },
              ...(customOptions == null ? void 0 : customOptions.length) ? { customizable_options: customOptions } : {}
            }
          ]
        };
        const configurableProduct = await context.$magento.api.addConfigurableProductsToQuote(
          configurableCartInput
        );
        Logger.debug("[Result]:", { data: configurableProduct.data });
        if (((_b = configurableProduct.errors) == null ? void 0 : _b.length) > 0) {
          throw new Error(String(configurableProduct.errors[0].message));
        }
        return configurableProduct.data.addConfigurableProductsToCart.cart;
      case "BundleProduct":
        const createEnteredOptions = () => product.bundle_options.map((bundleOption) => ({
          ...bundleOption,
          value: bundleOption.value.toString()
        }));
        const bundleCartInput = {
          cart_id: cartId,
          cart_items: [
            {
              data: {
                quantity,
                sku: product.sku
              },
              bundle_options: createEnteredOptions(),
              ...(customOptions == null ? void 0 : customOptions.length) ? { customizable_options: customOptions } : {}
            }
          ]
        };
        const bundleProduct = await context.$magento.api.addBundleProductsToQuote(
          bundleCartInput
        );
        Logger.debug("[Result]:", { data: bundleProduct });
        if (bundleProduct.errors.length > 0) {
          throw new Error(String(bundleProduct.errors[0].message));
        }
        return bundleProduct.data.addBundleProductsToCart.cart;
      case "DownloadableProduct":
        const downloadableCartInput = {
          cart_id: cartId,
          cart_items: [
            {
              data: {
                quantity,
                sku: product.sku
              },
              ...(customOptions == null ? void 0 : customOptions.length) ? { customizable_options: customOptions } : {}
            }
          ]
        };
        const downloadableProduct = await context.$magento.api.addDownloadableProductsToCart(
          downloadableCartInput
        );
        Logger.debug("[Result DownloadableProduct]:", { data: downloadableProduct });
        if (((_c = downloadableProduct.errors) == null ? void 0 : _c.length) > 0) {
          throw new Error(String(downloadableProduct.errors[0].message));
        }
        return downloadableProduct.data.addDownloadableProductToCart.cart;
      case "VirtualProduct":
        const virtualCartInput = {
          cart_id: cartId,
          cart_items: [
            {
              data: {
                quantity,
                sku: product.sku
              },
              ...(customOptions == null ? void 0 : customOptions.length) ? { customizable_options: customOptions } : {}
            }
          ]
        };
        const virtualProduct = await context.$magento.api.addVirtualProductsToCart(
          virtualCartInput
        );
        Logger.debug("[Result VirtualProduct]:", { data: virtualProduct });
        if (((_d = virtualProduct.errors) == null ? void 0 : _d.length) > 0) {
          throw new Error(String(virtualProduct.errors[0].message));
        }
        return virtualProduct.data.addVirtualProductsToCart.cart;
      case "GroupedProduct":
        const groupedCartInput = {
          cartId,
          cartItems: product.items.map((item) => ({
            quantity,
            sku: item.product.sku
          }))
        };
        const groupedProduct = await context.$magento.api.addProductsToQuote(groupedCartInput);
        Logger.debug("[Result GroupedProduct]:", { data: groupedProduct });
        if (groupedProduct.data.addProductsToCart.user_errors.length > 0) {
          throw new Error(String(groupedProduct.data.addProductsToCart.user_errors[0].message));
        }
        return groupedProduct.data.addProductsToCart.cart;
      default:
        throw new Error(`Product Type ${product.__typename} not supported in add to cart yet`);
    }
  }
};
export {
  addItemCommand
};
